import { gql } from '@apollo/client';

import { ProfileItemFragment } from './profile-item';

export const ProfileSectionFragment = gql`
    fragment ProfileSection on ProfileSection {
        name
        items {
            ...ProfileItem
        }
    }
    ${ProfileItemFragment}
`;
